export default __webpack_public_path__ + "static/media/magazine2.088b4bb5.jpg";